import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy, deserializationPolicy, generateUuid, HttpHeaders, WebResource, isTokenCredential, bearerTokenAuthenticationPolicy, isNode } from "@azure/core-http";
import { SpanStatusCode } from "@azure/core-tracing";
import { AnonymousCredential } from "./credentials/AnonymousCredential";
import { BlobClient } from "./Clients";
import { Mutex } from "./utils/Mutex";
import { Pipeline } from "./Pipeline";
import { attachCredential, getURLPath, getURLPathAndQuery, iEqual } from "./utils/utils.common";
import { HeaderConstants, BATCH_MAX_REQUEST, HTTP_VERSION_1_1, HTTP_LINE_ENDING, StorageOAuthScopes } from "./utils/constants";
import { StorageSharedKeyCredential } from "./credentials/StorageSharedKeyCredential";
import { createSpan } from "./utils/tracing";
/**
 * A BlobBatch represents an aggregated set of operations on blobs.
 * Currently, only `delete` and `setAccessTier` are supported.
 */

export var BlobBatch = /*#__PURE__*/function () {
  function BlobBatch() {
    _classCallCheck(this, BlobBatch);

    this.batch = "batch";
    this.batchRequest = new InnerBatchRequest();
  }
  /**
   * Get the value of Content-Type for a batch request.
   * The value must be multipart/mixed with a batch boundary.
   * Example: multipart/mixed; boundary=batch_a81786c8-e301-4e42-a729-a32ca24ae252
   */


  _createClass(BlobBatch, [{
    key: "getMultiPartContentType",
    value: function getMultiPartContentType() {
      return this.batchRequest.getMultipartContentType();
    }
    /**
     * Get assembled HTTP request body for sub requests.
     */

  }, {
    key: "getHttpRequestBody",
    value: function getHttpRequestBody() {
      return this.batchRequest.getHttpRequestBody();
    }
    /**
     * Get sub requests that are added into the batch request.
     */

  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      return this.batchRequest.getSubRequests();
    }
  }, {
    key: "addSubRequestInternal",
    value: function () {
      var _addSubRequestInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(subRequest, assembleSubRequestFunc) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Mutex.lock(this.batch);

              case 2:
                _context.prev = 2;
                this.batchRequest.preAddSubRequest(subRequest);
                _context.next = 6;
                return assembleSubRequestFunc();

              case 6:
                this.batchRequest.postAddSubRequest(subRequest);

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return Mutex.unlock(this.batch);

              case 10:
                return _context.finish(7);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 7, 11]]);
      }));

      function addSubRequestInternal(_x, _x2) {
        return _addSubRequestInternal.apply(this, arguments);
      }

      return addSubRequestInternal;
    }()
  }, {
    key: "setBatchType",
    value: function setBatchType(batchType) {
      if (!this.batchType) {
        this.batchType = batchType;
      }

      if (this.batchType !== batchType) {
        throw new RangeError("BlobBatch only supports one operation type per batch and it already is being used for ".concat(this.batchType, " operations."));
      }
    }
  }, {
    key: "deleteBlob",
    value: function () {
      var _deleteBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(urlOrBlobClient, credentialOrOptions, options) {
        var _this = this;

        var url, credential, _createSpan, span, updatedOptions;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof urlOrBlobClient === "string" && (isNode && credentialOrOptions instanceof StorageSharedKeyCredential || credentialOrOptions instanceof AnonymousCredential || isTokenCredential(credentialOrOptions)))) {
                  _context3.next = 5;
                  break;
                }

                // First overload
                url = urlOrBlobClient;
                credential = credentialOrOptions;
                _context3.next = 12;
                break;

              case 5:
                if (!(urlOrBlobClient instanceof BlobClient)) {
                  _context3.next = 11;
                  break;
                }

                // Second overload
                url = urlOrBlobClient.url;
                credential = urlOrBlobClient.credential;
                options = credentialOrOptions;
                _context3.next = 12;
                break;

              case 11:
                throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");

              case 12:
                if (!options) {
                  options = {};
                }

                _createSpan = createSpan("BatchDeleteRequest-addSubRequest", options), span = _createSpan.span, updatedOptions = _createSpan.updatedOptions;
                _context3.prev = 14;
                this.setBatchType("delete");
                _context3.next = 18;
                return this.addSubRequestInternal({
                  url: url,
                  credential: credential
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return new BlobClient(url, _this.batchRequest.createPipeline(credential)).delete(updatedOptions);

                        case 2:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](14);
                span.setStatus({
                  code: SpanStatusCode.ERROR,
                  message: _context3.t0.message
                });
                throw _context3.t0;

              case 24:
                _context3.prev = 24;
                span.end();
                return _context3.finish(24);

              case 27:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[14, 20, 24, 27]]);
      }));

      function deleteBlob(_x3, _x4, _x5) {
        return _deleteBlob.apply(this, arguments);
      }

      return deleteBlob;
    }()
  }, {
    key: "setBlobAccessTier",
    value: function () {
      var _setBlobAccessTier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(urlOrBlobClient, credentialOrTier, tierOrOptions, options) {
        var _this2 = this;

        var url, credential, tier, _createSpan2, span, updatedOptions;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(typeof urlOrBlobClient === "string" && (isNode && credentialOrTier instanceof StorageSharedKeyCredential || credentialOrTier instanceof AnonymousCredential || isTokenCredential(credentialOrTier)))) {
                  _context5.next = 6;
                  break;
                }

                // First overload
                url = urlOrBlobClient;
                credential = credentialOrTier;
                tier = tierOrOptions;
                _context5.next = 14;
                break;

              case 6:
                if (!(urlOrBlobClient instanceof BlobClient)) {
                  _context5.next = 13;
                  break;
                }

                // Second overload
                url = urlOrBlobClient.url;
                credential = urlOrBlobClient.credential;
                tier = credentialOrTier;
                options = tierOrOptions;
                _context5.next = 14;
                break;

              case 13:
                throw new RangeError("Invalid arguments. Either url and credential, or BlobClient need be provided.");

              case 14:
                if (!options) {
                  options = {};
                }

                _createSpan2 = createSpan("BatchSetTierRequest-addSubRequest", options), span = _createSpan2.span, updatedOptions = _createSpan2.updatedOptions;
                _context5.prev = 16;
                this.setBatchType("setAccessTier");
                _context5.next = 20;
                return this.addSubRequestInternal({
                  url: url,
                  credential: credential
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return new BlobClient(url, _this2.batchRequest.createPipeline(credential)).setAccessTier(tier, updatedOptions);

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })));

              case 20:
                _context5.next = 26;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5["catch"](16);
                span.setStatus({
                  code: SpanStatusCode.ERROR,
                  message: _context5.t0.message
                });
                throw _context5.t0;

              case 26:
                _context5.prev = 26;
                span.end();
                return _context5.finish(26);

              case 29:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[16, 22, 26, 29]]);
      }));

      function setBlobAccessTier(_x6, _x7, _x8, _x9) {
        return _setBlobAccessTier.apply(this, arguments);
      }

      return setBlobAccessTier;
    }()
  }]);

  return BlobBatch;
}();
/**
 * Inner batch request class which is responsible for assembling and serializing sub requests.
 * See https://docs.microsoft.com/en-us/rest/api/storageservices/blob-batch#request-body for how requests are assembled.
 */

var InnerBatchRequest = /*#__PURE__*/function () {
  function InnerBatchRequest() {
    _classCallCheck(this, InnerBatchRequest);

    this.operationCount = 0;
    this.body = "";
    var tempGuid = generateUuid(); // batch_{batchid}

    this.boundary = "batch_".concat(tempGuid); // --batch_{batchid}
    // Content-Type: application/http
    // Content-Transfer-Encoding: binary

    this.subRequestPrefix = "--".concat(this.boundary).concat(HTTP_LINE_ENDING).concat(HeaderConstants.CONTENT_TYPE, ": application/http").concat(HTTP_LINE_ENDING).concat(HeaderConstants.CONTENT_TRANSFER_ENCODING, ": binary"); // multipart/mixed; boundary=batch_{batchid}

    this.multipartContentType = "multipart/mixed; boundary=".concat(this.boundary); // --batch_{batchid}--

    this.batchRequestEnding = "--".concat(this.boundary, "--");
    this.subRequests = new Map();
  }
  /**
   * Create pipeline to assemble sub requests. The idea here is to use existing
   * credential and serialization/deserialization components, with additional policies to
   * filter unnecessary headers, assemble sub requests into request's body
   * and intercept request from going to wire.
   * @param credential -  Such as AnonymousCredential, StorageSharedKeyCredential or any credential from the `@azure/identity` package to authenticate requests to the service. You can also provide an object that implements the TokenCredential interface. If not specified, AnonymousCredential is used.
   */


  _createClass(InnerBatchRequest, [{
    key: "createPipeline",
    value: function createPipeline(credential) {
      var isAnonymousCreds = credential instanceof AnonymousCredential;
      var policyFactoryLength = 3 + (isAnonymousCreds ? 0 : 1); // [deserializationPolicy, BatchHeaderFilterPolicyFactory, (Optional)Credential, BatchRequestAssemblePolicyFactory]

      var factories = new Array(policyFactoryLength);
      factories[0] = deserializationPolicy(); // Default deserializationPolicy is provided by protocol layer

      factories[1] = new BatchHeaderFilterPolicyFactory(); // Use batch header filter policy to exclude unnecessary headers

      if (!isAnonymousCreds) {
        factories[2] = isTokenCredential(credential) ? attachCredential(bearerTokenAuthenticationPolicy(credential, StorageOAuthScopes), credential) : credential;
      }

      factories[policyFactoryLength - 1] = new BatchRequestAssemblePolicyFactory(this); // Use batch assemble policy to assemble request and intercept request from going to wire

      return new Pipeline(factories, {});
    }
  }, {
    key: "appendSubRequestToBody",
    value: function appendSubRequestToBody(request) {
      // Start to assemble sub request
      this.body += [this.subRequestPrefix, "".concat(HeaderConstants.CONTENT_ID, ": ").concat(this.operationCount), "", "".concat(request.method.toString(), " ").concat(getURLPathAndQuery(request.url), " ").concat(HTTP_VERSION_1_1).concat(HTTP_LINE_ENDING) // sub request start line with method
      ].join(HTTP_LINE_ENDING);

      var _iterator = _createForOfIteratorHelper(request.headers.headersArray()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var header = _step.value;
          this.body += "".concat(header.name, ": ").concat(header.value).concat(HTTP_LINE_ENDING);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.body += HTTP_LINE_ENDING; // sub request's headers need be ending with an empty line
      // No body to assemble for current batch request support
      // End to assemble sub request
    }
  }, {
    key: "preAddSubRequest",
    value: function preAddSubRequest(subRequest) {
      if (this.operationCount >= BATCH_MAX_REQUEST) {
        throw new RangeError("Cannot exceed ".concat(BATCH_MAX_REQUEST, " sub requests in a single batch"));
      } // Fast fail if url for sub request is invalid


      var path = getURLPath(subRequest.url);

      if (!path || path === "") {
        throw new RangeError("Invalid url for sub request: '".concat(subRequest.url, "'"));
      }
    }
  }, {
    key: "postAddSubRequest",
    value: function postAddSubRequest(subRequest) {
      this.subRequests.set(this.operationCount, subRequest);
      this.operationCount++;
    } // Return the http request body with assembling the ending line to the sub request body.

  }, {
    key: "getHttpRequestBody",
    value: function getHttpRequestBody() {
      return "".concat(this.body).concat(this.batchRequestEnding).concat(HTTP_LINE_ENDING);
    }
  }, {
    key: "getMultipartContentType",
    value: function getMultipartContentType() {
      return this.multipartContentType;
    }
  }, {
    key: "getSubRequests",
    value: function getSubRequests() {
      return this.subRequests;
    }
  }]);

  return InnerBatchRequest;
}();

var BatchRequestAssemblePolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(BatchRequestAssemblePolicy, _BaseRequestPolicy);

  function BatchRequestAssemblePolicy(batchRequest, nextPolicy, options) {
    var _this3;

    _classCallCheck(this, BatchRequestAssemblePolicy);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(BatchRequestAssemblePolicy).call(this, nextPolicy, options));
    _this3.dummyResponse = {
      request: new WebResource(),
      status: 200,
      headers: new HttpHeaders()
    };
    _this3.batchRequest = batchRequest;
    return _this3;
  }

  _createClass(BatchRequestAssemblePolicy, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(request) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.batchRequest.appendSubRequestToBody(request);

              case 2:
                return _context6.abrupt("return", this.dummyResponse);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendRequest(_x10) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  }]);

  return BatchRequestAssemblePolicy;
}(BaseRequestPolicy);

var BatchRequestAssemblePolicyFactory = /*#__PURE__*/function () {
  function BatchRequestAssemblePolicyFactory(batchRequest) {
    _classCallCheck(this, BatchRequestAssemblePolicyFactory);

    this.batchRequest = batchRequest;
  }

  _createClass(BatchRequestAssemblePolicyFactory, [{
    key: "create",
    value: function create(nextPolicy, options) {
      return new BatchRequestAssemblePolicy(this.batchRequest, nextPolicy, options);
    }
  }]);

  return BatchRequestAssemblePolicyFactory;
}();

var BatchHeaderFilterPolicy = /*#__PURE__*/function (_BaseRequestPolicy2) {
  _inherits(BatchHeaderFilterPolicy, _BaseRequestPolicy2);

  // The base class has a protected constructor. Adding a public one to enable constructing of this class.

  /* eslint-disable-next-line @typescript-eslint/no-useless-constructor*/
  function BatchHeaderFilterPolicy(nextPolicy, options) {
    _classCallCheck(this, BatchHeaderFilterPolicy);

    return _possibleConstructorReturn(this, _getPrototypeOf(BatchHeaderFilterPolicy).call(this, nextPolicy, options));
  }

  _createClass(BatchHeaderFilterPolicy, [{
    key: "sendRequest",
    value: function () {
      var _sendRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(request) {
        var xMsHeaderName, _iterator2, _step2, header;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                xMsHeaderName = "";
                _iterator2 = _createForOfIteratorHelper(request.headers.headersArray());

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    header = _step2.value;

                    if (iEqual(header.name, HeaderConstants.X_MS_VERSION)) {
                      xMsHeaderName = header.name;
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                if (xMsHeaderName !== "") {
                  request.headers.remove(xMsHeaderName); // The subrequests should not have the x-ms-version header.
                }

                return _context7.abrupt("return", this._nextPolicy.sendRequest(request));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sendRequest(_x11) {
        return _sendRequest2.apply(this, arguments);
      }

      return sendRequest;
    }()
  }]);

  return BatchHeaderFilterPolicy;
}(BaseRequestPolicy);

var BatchHeaderFilterPolicyFactory = /*#__PURE__*/function () {
  function BatchHeaderFilterPolicyFactory() {
    _classCallCheck(this, BatchHeaderFilterPolicyFactory);
  }

  _createClass(BatchHeaderFilterPolicyFactory, [{
    key: "create",
    value: function create(nextPolicy, options) {
      return new BatchHeaderFilterPolicy(nextPolicy, options);
    }
  }]);

  return BatchHeaderFilterPolicyFactory;
}();